import { legacy_createStore as createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
// import logger from 'redux-logger';
import aboutusReducer from './aboutus_block/Aboutus';
import homeReducer from './home_block/homeReducer';
import contactUsReducer from './contact_us_block/contactUsReducer';

// Combine all reducers into one place
const rootReducer = combineReducers({
  Aboutus: aboutusReducer,
  Home: homeReducer,
  ContactUs: contactUsReducer,
});

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk)),
  // composeWithDevTools(applyMiddleware(thunk, logger)),
);

export default store;

export { rootReducer };
